export interface LoadingConfig {
    maximumLoaderDelayInMs: number;
}

export const loadingConfig: LoadingConfig = {
    maximumLoaderDelayInMs: 3000
};
